var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"dev"},[_vm._v(" https://pay.jp/docs/testcard "),_c('label',{attrs:{"for":"card-element"}},[_vm._v(" カード ")]),_c('div',{attrs:{"id":"card-element"}}),_c('v-btn',{on:{"click":_vm.submit}},[_vm._v(" submit ")]),_vm._v(" "+_vm._s(_vm.cards)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }